import { TripoTagProps } from './TripoTag'

const useTripoTagAdditionalClassProps = (props: TripoTagProps): string => {
    let additionalClassNames = ''
    if (props.size === 'huge') additionalClassNames += `${additionalClassNames} tripo-ant-tag-size-huge`
    if (props.round) additionalClassNames += `${additionalClassNames} tripo-ant-tag-rounded`

    return `${props.className} ${additionalClassNames}`
}

export default useTripoTagAdditionalClassProps
